// Joins class names, dropping the falsy ones: cn('a', on && 'b', undefined).
export function cn(...parts: (string | false | null | undefined)[]): string {
  return parts.filter(Boolean).join(' ');
}

/** Monospace text inside running text (IDs, paths, branches): a touch smaller and tighter. */
export const mono = 'font-mono text-[0.92em] tracking-[-0.01em]';
